import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f31b5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column w-full gap-4 w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-2xl font-semibold" }
const _hoisted_4 = { class: "flex flex-column justify-content-center align-items-center border-1 border-300 border-round-2xl border-dashed p-4 mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/routePlanner/recent.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "text-base text-600 px-6 text-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex w-full mt-auto justify-content-between align-items-center" }
const _hoisted_9 = { class: "text-2xl font-semibold" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex mt-auto align-items-center w-full justify-content-between border-bottom-1 border-gray-400" }
const _hoisted_12 = { class: "flex flex-column gap-1 w-full pb-1" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "text-sm text-500 max-w-fit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGps = _resolveComponent("IconGps")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.recentLocations && _ctx.recentLocations.total === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("route_planner.recent")), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("route_planner.no_recent")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("route_planner.recent")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentLocations?.data, (location, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex mt-4 w-full gap-4 align-items-center pb-1 cursor-pointer",
              key: index,
              onClick: ($event: any) => (_ctx.selectLocation(location))
            }, [
              _createVNode(_component_IconGps, { class: "text-2xl thin-icon" }),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(location.title), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(location.address), 1)
                ])
              ])
            ], 8, _hoisted_10))
          }), 128))
        ])),
    (_ctx.showLoadMore)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          class: "p-button border-none shadow-none hover:bg-transparent focus:ring-0 text-gray-800 -mt-8 w-full pt-8 button-gradient",
          label: _ctx.$t('route_planner.show_more'),
          onClick: _ctx.loadMore
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}